// src/Login.js

import {
  GoogleAuthProvider,
  signInWithPopup,
  setPersistence,
  browserSessionPersistence
} from "firebase/auth";

import { auth, db } from "./firebase";
import {
  setDoc,
  doc,
  getDoc,
  serverTimestamp
} from "firebase/firestore";

export default function Login() {
  const handleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await setPersistence(auth, browserSessionPersistence);
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        // ✅ Update only login time
        await setDoc(userRef, {
          lastLogin: serverTimestamp()
        }, { merge: true });
      } else {
        // 🆕 First time user — create with lastGenerated
        await setDoc(userRef, {
          uid: user.uid,
          name: user.displayName,
          email: user.email,
          photoURL: user.photoURL,
          lastLogin: serverTimestamp(),
          lastGenerated: null  // 👈 Add this so we can track reel usage
        });
      }

      window.location.href = "/dashboard";
    } catch (err) {
      console.error("Login failed:", err);
      alert("❌ Login failed. Please try again.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-10 rounded-xl shadow-lg space-y-4 text-center">
        <h1 className="text-2xl font-bold">🔐 Join Beta Access</h1>
        <p className="text-gray-600">
          Sign in with Google to generate your weekly reels.
        </p>
        <button
          onClick={handleLogin}
          className="bg-red-500 text-white px-6 py-2 rounded-md hover:bg-red-600"
        >
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
